const IconSlash = (): JSX.Element => {
  return (
    <>
      <path d="M10.5 3.5L7.18329 13.5H5.5L8.81671 3.5H10.5Z" fill="#888888" />
    </>
  );
};

export default IconSlash;
